import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import LocalizedLink from "../LocalizedLink";
import useTranslations from "../useTranslations";
import useFlgas from "../useFlags";
import * as styles from "./career.module.css";

const JobOffers = ({ allMdx }) => {
  const { translate } = useStaticQuery(query);
  const { no_job_offers } = useTranslations(translate);
  const { show_job_offers } = useFlgas();

  const content =
    allMdx.edges.length !== 0 && show_job_offers ? (
      allMdx.edges.map(({ node }, index) => {
        return (
          <LocalizedLink
            key={index}
            to={node.fields.slug}
            type="career"
            aria-label={node.frontmatter.title}
          >
            <div className={styles.box_curriculum}>
              <span className={styles.draw_line_work}>
                {node.frontmatter.title}
              </span>
            </div>
          </LocalizedLink>
        );
      })
    ) : (
      <p>{no_job_offers}</p>
    );
  return <div className={`container ${styles.challenge}`}>{content}</div>;
};

export default JobOffers;

const query = graphql`
  query JobOffers {
    translate: allFile(filter: { sourceInstanceName: { eq: "translations" } }) {
      edges {
        node {
          name
          translations: childTranslationsJson {
            no_job_offers
          }
        }
      }
    }
  }
`;
